export default {
  'MENU' (state) {
    return state.menu
  },
  'MENUS' (state) {
    return state.menus
  }
}
